export default "__VITE_ASSET__3bac1518__"